import { useEffect, useState } from 'react';

/**
 * "New version ready" bar, in place of the old confirm() in index.js - browsers skip a
 * confirm() in a tab that isn't in front (it counted as Cancel), so the update was missed.
 *
 * index.js fires `osprey-update-ready` when a new service worker takes over a page an old
 * one was running. Never reloads by itself, and stays hidden mid-match (`scouting`): a
 * reload there would lose the match.
 */
export const UPDATE_READY_EVENT = 'osprey-update-ready';

export default function UpdateBanner({ scouting }) {
    const [ready, setReady] = useState(() => Boolean(window.__ospreyUpdateReady));
    const [later, setLater] = useState(false);

    useEffect(() => {
        const onReady = () => setReady(true);
        window.addEventListener(UPDATE_READY_EVENT, onReady);
        return () => window.removeEventListener(UPDATE_READY_EVENT, onReady);
    }, []);

    if (!ready || later || scouting) return null;
    return (
        <div className='updateBanner' role='status'>
            <span className='updateBannerText'>New version of Osprey ready</span>
            <button className='updateBannerReload' onClick={() => window.location.reload()}>Reload</button>
            <button className='updateBannerLater' onClick={() => setLater(true)}>Later</button>
        </div>
    );
}
